import { localize } from 'commons/LocalizedText/LocalizedText';
import { generateRow } from 'utils/helpers/RowHelper';
import Tooltip from '@material-ui/core/Tooltip';

export const mailOrLoginRow = generateRow({
  name: 'mailOrLogin',
  label: 'contactMailOrLogin',
  width: '20%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.mailOrLogin}
    </div>
  )
});

export const lastnameRow = generateRow({
  name: 'lastname',
  label: 'contact.lastName',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.lastname}
    </div>
  )
});

export const firstnameRow = generateRow({
  name: 'firstname',
  label: 'contact.firstName',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.firstname}
    </div>
  )
});

export const statusRow = generateRow({
  label: 'contactStatus',
  name: 'status',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {localize(row.status)}
    </div>
  )
})

export const profileRow = generateRow({
  name: 'profile',
  label: 'account.profile',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {localize(row.profile)}
    </div>
  )
});

export const programRow = generateRow({
  name: 'program',
  label: 'details.programs',
  width: '50%',
  mobileWidth: '40%',
  isSortable: false,
  template: (row) => {
    const programs = row.programList?.split(',') || [];
    const threshold = 3;
    const divider = ',';
    const programsString = (programs.length > threshold)
      ? programs.slice(0,threshold).join(divider) + '... +' + (programs.length - threshold)
      : programs.join(divider)

    return (
      <div>
        <Tooltip title={programs.join(divider)}>
          <p>{programsString}</p>
        </Tooltip>
      </div>
    )
  }
});